import { PropsFilesPdfWrapper } from './types'
import { LayoutGallery } from './LayoutGalleryPDF'
import { card } from '../../../../common/components/CardEditor'
import { getPdf } from './getPdf'
import ContentFileName, { FileNameIcon } from './ContentFileName'
import i18n from 'live/services/i18n'

export default card<PropsFilesPdfWrapper>({
    title: i18n('PDF CONFIGURATION'),
    className: 'emailPDFBodyConfiguration',
    get: getPdf,
    set: function ({ page, files }, report) {
        report.page = page
        report.files.pdf = files
        return report
    },
    actionsHeader: [
        {
            icone: FileNameIcon,
            actionComponent: ContentFileName,
            hideOnDisplayMode: true
        }
    ],
    collapseStartsClosed: true,
    collapseOnHideClosed: true
})(LayoutGallery)
